import React, { Component } from 'react';
import { connect } from 'react-redux';
import NextSvg from '../../../assets/chevronRight.svg';
import PrevSvg from '../../../assets/chevronLeft.svg';
import { v4 as uuidv4 } from 'uuid';
import './paginator.scss';

class Pagination extends Component {
  state={
    currentPageNo: typeof this.props.initialPageNo === "number" ? this.props.initialPageNo : 1,
    isLastPage: typeof this.props.isLastPage === "boolean" ? this.props.isLastPage : false,
    isFirstPage: true,
    pageSize: (typeof this.props.pageSize === "number" && this.props.pageSize > 0) ? this.props.pageSize : 10,
    resetOnChange: this.props.resetOnChange || `id-${uuidv4()}`
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.isLastPage !== this.props.isLastPage) {
      this.setState({isLastPage :this.props.isLastPage});
    }
    if(prevProps.resetOnChange !== this.props.resetOnChange) {
      this.setState({resetOnChange: this.props.resetOnChange, currentPageNo: 1, isFirstPage: true});
    }
    if(prevProps.pageSize !== this.props.pageSize) {
      this.setState({pageSize: (typeof this.props.pageSize === "number" && this.props.pageSize > 0) ? this.props.pageSize : 10});
    }
  }

  // When a numeric totalRecords is supplied (renderFullPage callers), last-page is derived from the
  // LIVE page number this component owns + the total — correct even on an exactly-full final page,
  // which the data.length<pageSize sentinel cannot distinguish from "a full page with more to come".
  // Without a total, fall back to that sentinel (the offset/"peek" callers).
  isLastPageNow = () => {
    if (typeof this.props.totalRecords === "number") {
      return this.state.currentPageNo * this.state.pageSize >= this.props.totalRecords;
    }
    return this.state.isLastPage;
  }

  previousPage = () => {
    if(this.state.currentPageNo > 1) {
      let tmpPageNo = this.state.currentPageNo - 1;
      this.setState({currentPageNo: tmpPageNo, isFirstPage: (tmpPageNo <= 1) ? true : false })
      if(typeof this.props.getPrevPageData === 'function')
        this.props.getPrevPageData(tmpPageNo, this.state.pageSize);
    } else {
      this.setState({isFirstPage: true})
    }
  }

  nextPage = () => {
    if(!this.isLastPageNow()) {
      let tmpPageNo = this.state.currentPageNo + 1;
      this.setState({currentPageNo: tmpPageNo, isFirstPage: false})
      if(typeof this.props.getNextPageData === 'function')
        this.props.getNextPageData(tmpPageNo, this.state.pageSize);
    }
  }

  render() {
    const isLastPage = this.isLastPageNow();
    return (
      <div className="d-flex justify-content-center">
        <button className="page-navigation mx-2 page-nav-active" data-toggle="tooltip" data-placement="top" title="Previous Page" onClick={this.previousPage}>
          <img src={PrevSvg} width="24px" alt="" />
        </button>
        <div className="mx-2 ">{this.state.isFirstPage ? "": "..."}</div>

        <div className="mx-2 page-no"> {this.state.currentPageNo <= 1 ? "" : this.state.currentPageNo - 1} </div>
        
        <div className="mx-2 current-page-no">{this.state.currentPageNo}</div>

        <div className="mx-2 page-no"> {isLastPage ? "" : this.state.currentPageNo + 1} </div>

        <div className="mx-2 ">{isLastPage ? "": "..."}</div>

        <button className="page-navigation mx-2 page-nav-active" data-toggle="tooltip" data-placement="top" title="Next Page" onClick={this.nextPage} disabled={this.props.loaderFlag}>
          <img src={NextSvg} width="24px" alt="" />
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);
